import { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'

function MovingTicker({ images }) {
  const containerRef = useRef(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    console.log('MovingTicker mounted with images:', images)
    if (!images || images.length === 0) {
      console.log('No images provided to MovingTicker')
      return
    }

    const container = containerRef.current
    if (!container) return

    const scrollWidth = container.scrollWidth
    const clientWidth = container.clientWidth
    let scrollPosition = 0

    const scroll = () => {
      scrollPosition += 1
      if (scrollPosition >= scrollWidth / 2) {
        scrollPosition = 0
      }
      container.scrollLeft = scrollPosition
    }

    const interval = setInterval(scroll, 30)

    // Set loading to false after a short delay to ensure images are loaded
    const loadingTimeout = setTimeout(() => {
      setIsLoading(false)
    }, 1000)

    return () => {
      clearInterval(interval)
      clearTimeout(loadingTimeout)
    }
  }, [images])

  if (!images || images.length === 0) {
    return (
      <div className="w-full h-[300px] flex items-center justify-center bg-gray-100 rounded-lg">
        <p className="text-gray-500">No images available</p>
      </div>
    )
  }

  return (
    <div className="w-full overflow-hidden bg-white py-8 border-2 border-pacieh-blue rounded-lg">
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/80 z-10">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pacieh-blue"></div>
        </div>
      )}
      <div
        ref={containerRef}
        className="flex space-x-6 overflow-x-hidden"
        style={{ scrollBehavior: 'smooth' }}
      >
        {/* First set of images */}
        {images.map((image, index) => (
          <motion.div
            key={`first-${index}`}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="flex-shrink-0 w-[400px] h-[300px] rounded-lg overflow-hidden shadow-lg border-2 border-pacieh-green"
          >
            <img
              src={image}
              alt={`Impact Image ${index + 1}`}
              className="w-full h-full object-cover"
              onLoad={() => console.log(`Image ${index} loaded successfully`)}
              onError={(e) => console.error(`Error loading image ${index}:`, e)}
            />
          </motion.div>
        ))}
        {/* Duplicate set for seamless loop */}
        {images.map((image, index) => (
          <motion.div
            key={`second-${index}`}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="flex-shrink-0 w-[400px] h-[300px] rounded-lg overflow-hidden shadow-lg border-2 border-pacieh-green"
          >
            <img
              src={image}
              alt={`Impact Image ${index + 1}`}
              className="w-full h-full object-cover"
              onLoad={() => console.log(`Image ${index} loaded successfully`)}
              onError={(e) => console.error(`Error loading image ${index}:`, e)}
            />
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default MovingTicker 